// @flow
import ItemDetails, { dateFormat } from './ItemDetails';

export default ItemDetails;
export { dateFormat };
